const Theme = {
  body_background_color: '#3D2A19',
  logo_image_url:'fba.png',
  number_hidden:true,
  token_hidden:true,
  header_full_height:true,

  title_uppercase:true,

  card_background_color: '#F7F7F7',
  // card_background_color: '#3D2A19',

  button_color: '#F7F7F7',
  button_text_color: '#3D2A19',
  button_border_color: '#3D2A19',
  button_hover_color: '#3D2A19',
  button_hover_text_color: '#F7F7F7',
  button_hover_border_color: '#3D2A19',

  button_outlined_text_color: '#F7F7F7',
  button_outlined_color: '#3D2A19',
  button_outlined_hover_text_color: '#3D2A19',
  button_outlined_hover_color: '#F7F7F7',
  button_outlined_hover_border_color: '#3D2A19',

  button_radius: 25,
  button_border_width:2,

  text_font: 'Helvetica',
  text_color: 'black',

  title_font: 'Preview Univers Condensed',
  title_weight: 400,
  subtitle_font: 'Preview Univers Condensed',
}

export default Theme
